module.exports = __webpack_public_path__ + "static/media/xiaoguopingubiao.1c7426b5.png";